import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Mastery over memorisation",
    body: "We do not teach to the test. We teach until the concept is yours — until you can rebuild it from first principles and defend it out loud.",
  },
  {
    num: "02",
    title: "Small rooms, high standards",
    body: "Cohorts stay intentionally small. Instructors know your name, your gaps, and your ambition. Feedback is direct, frequent, and human.",
  },
  {
    num: "03",
    title: "Craft you can carry",
    body: "Every program ends with proof — a portfolio, a clinical hour log, a solved problem set, a talk delivered. You leave with evidence, not just a certificate.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Manifesto = () => (
  <section
    id="manifesto"
    data-testid="manifesto-section"
    className="relative bg-[#050505] px-6 md:px-12 py-28 md:py-40"
  >
    <div className="mx-auto max-w-[1600px]">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="mb-20 max-w-3xl"
      >
        <span className="text-xs uppercase tracking-[0.4em] text-[#7C3AED]">The Manifesto</span>
        <h2 className="mt-6 font-serif-ed text-4xl md:text-6xl leading-tight text-white">
          We build learners who can <em className="text-[#7C3AED]">do</em>, not
          just recite.
        </h2>
      </motion.div>

      <div className="grid gap-x-12 gap-y-16 md:grid-cols-3">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            data-testid={`manifesto-chapter-${c.num}`}
            className="relative"
          >
            <div className="font-serif-ed text-8xl md:text-9xl leading-none text-white/10">
              {c.num}
            </div>
            <h3 className="mt-4 font-display text-2xl uppercase tracking-tight text-white">
              {c.title}
            </h3>
            <p className="mt-4 text-white/60 leading-relaxed">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
